import React from "react";

const InputNumberItemTable = ({ value, setValue,title }) => {
  return (
    <div className="my-3">
    
      <input
        type="number"
        min={0}
        id={title}
        value={value}
        onChange={(e)=>setValue(e.target.value)}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
        placeholder={""}
        required
      />
    </div>
  );
};

export default InputNumberItemTable;
